<app-component-wrapper class="w-100 mr-3 flex-fill" compclass="flex-fill " infinitescroll
  (event)="endOfPageFullEvent()">

  <div class="d-flex flex-column flex-fill" slot="start">
    <div id="submitted-contributions-overview-container" class="card" endofpage (event)="endOfPageEvent()"
      [class.compact]="fullpage == false">


      <app-no-items message="No submitted contribution found" *ngIf="(list$ |async)?.length === 0"></app-no-items>
      <div class="table-wrapper">
        <table class="table " *ngIf="(list$ |async)?.length > 0">
          <thead>
            <tr>
              <th scope="col">Contribution Description</th>
              <th scope="col">Submitted Date</th>
              <th scope="col">Amount</th>
              <th scope="col">Number of Employees</th>
              <th scope="col">Reference</th>
              <th scope="col" style="width: 80px;"></th>
              <!-- <th scope="col">Copy</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of list$ | async" class="click"
              routerLink="/view-contribution/{{item.employerContributionHeaderId}}">
              <td>{{item.description}}</td>
              <td>{{item.submittedDate | date:'dd/MM/yyyy'}}
              </td>
              <td>{{item.amount | currency}}</td>
              <td>{{item.numberOfEmployees}}</td>
              <td>{{item.reference }}</td>
              <td>
                <app-button title="View" icon="chevron_right" routerLink="/view-contribution/{{item.employerContributionHeaderId}}">
                </app-button>

                <!-- <button class="option" mat-mini-fab [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item >
                    <mat-icon>chevron_right</mat-icon> View
                  </button>
                  <button mat-menu-item routerLink="/add-contribution/copy/{{item.contributionId}}">
                    <mat-icon>content_copy</mat-icon> Clone
                  </button>
                </mat-menu> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-component-wrapper>
